<template>
  <div id="assessmentStatistics">
    <div class="title">
      <img src="../../assets/image/icon_tj@2x.png" alt />
      <h3>业务考核</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="activeName">
        <el-tab-pane label="统计列表" name="1">
          <assessment-statistics-module />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import AssessmentStatisticsModule from '../../components/admin/AssessmentStatisticsModule'

export default {
  data() {
    return {
      activeName: '1',
    }
  },
  components: {
    AssessmentStatisticsModule,
  },
}
</script>

<style lang="less" scoped>
#assessmentStatistics {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;

  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;

    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }

    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }

  .tableContainer {
    width: 100%;
    height: calc(100% - 120px);
    border-radius: 10px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 40px 30px;
  }

  /deep/ .el-tabs {
    height: 100%;

    .el-tabs__header {
      margin-bottom: 20px;
    }

    .el-tabs__content {
      height: calc(100% - 80px);
    }

    .el-tab-pane {
      height: 100%;
    }
  }

  /deep/ .el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }

  /deep/ .el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #999;
    font-weight: 400;
    padding-right: 180px;
  }

  /deep/ .el-tabs__item.is-active,
  /deep/ .el-tabs__item:hover {
    color: #333 !important;
  }
}
</style>
